import { State } from "../../../state";

export const getDebugState = (state: State) => state.isDebug;



// WEBPACK FOOTER //
// ./src/spread/model/debug/selector.ts